module.exports = __webpack_public_path__ + "static/media/wheel-arrow.d30e0123.png";